function initMultiVariantForms() {
  document.querySelectorAll('.product-form__form').forEach((form) => {
    if (form.dataset.init) return;
    form.dataset.init = true;

    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;

    const productId = form.closest('.product-form').dataset.productId;
    const variantsData = document.getElementById(`variants-json-${productId}`);
    if (!variantsData) return;

    const variants = JSON.parse(variantsData.textContent);
    if (!Array.isArray(variants) || !variants[0]?.options) {
      console.error('Invalid variants data', variants);
      return;
    }

    // ⬇️ Get actual selected options from checked inputs instead of assuming defaults
    let selectedOptions = [];

    form.querySelectorAll('.product-option').forEach((group, idx) => {
      const checkedInput = group.querySelector('input[type="radio"]:checked');
      selectedOptions[idx] = checkedInput ? checkedInput.value : variants[0].options[idx];
    });

    const updateVariant = () => {
      const matchedVariant = variants.find((v) => v.options.every((opt, idx) => selectedOptions[idx] === opt));

      variantInput.value = matchedVariant?.available ? matchedVariant.id : '';

      form.querySelectorAll('.product-option').forEach((group, idx) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          const testCombo = [...selectedOptions];
          testCombo[idx] = input.value;

          const match = variants.find((v) => v.options.every((opt, i) => opt === testCombo[i]) && v.available);

          input.disabled = !match;

          const label = form.querySelector(`label[for="${input.id}"]`);
          if (label) {
            label.classList.toggle('disabled', !match);
          }
        });
      });
    };

    form.querySelectorAll('input.option-input').forEach((input) => {
      input.addEventListener('change', () => {
        const index = parseInt(input.dataset.optionIndex, 10);
        selectedOptions[index] = input.value;

        const group = input.closest('.product-option');
        group.querySelectorAll('input').forEach((i) => (i.checked = false));
        input.checked = true;

        group.querySelectorAll('label').forEach((label) => label.classList.remove('selected'));
        const selectedLabel = form.querySelector(`label[for="${input.id}"]`);
        if (selectedLabel) selectedLabel.classList.add('selected');

        updateVariant();
      });
    });

    // ✅ Trigger initial update with corrected selected options
    updateVariant();
  });
}

function initAutoSubmitSizeOptions() {
  document.querySelectorAll('.product-form').forEach((form) => {
    if (form.dataset.sizeInit) return;
    form.dataset.sizeInit = true;

    const sizeOptions = form.querySelectorAll('[data-option-type="size"] .option-input');
    const submitButton = form.querySelector('.btn.product-form__submit[data-has-color="true"]');

    sizeOptions.forEach((option) => {
      option.onclick = function () {
        setTimeout(() => {
          const selectedOption = form.querySelector('[data-option-type="size"] .option-input:checked');
          if (selectedOption && submitButton) {
            submitButton.click();
          }
        }, 50); // Delay to ensure radio is updated
      };
    });
  });
}

function initPopupHandlers() {
  // When quick buy is clicked
  document.querySelectorAll('.mobile_quickbuy_trigger').forEach((button) => {
    if (button.dataset.popupInit) return;
    button.dataset.popupInit = true;

    button.addEventListener('click', function () {
      // Remove 'active' from all product cards and buttons
      document.querySelectorAll('.product-card').forEach((card) => card.classList.remove('active'));
      document.querySelectorAll('.mobile_quickbuy_trigger').forEach((btn) => btn.classList.remove('active'));

      // Activate the current product card and button
      const productCard = this.closest('.product-card');
      productCard.classList.add('active');
      this.classList.add('active');
    });
  });

  // When close is clicked
  document.querySelectorAll('.close_button').forEach((button) => {
    if (button.dataset.closeInit) return;
    button.dataset.closeInit = true;

    button.addEventListener('click', function () {
      const productCard = this.closest('.product-card');
      const quickBuyButton = productCard.querySelector('.mobile_quickbuy_trigger');

      productCard.classList.remove('active');
      if (quickBuyButton) quickBuyButton.classList.remove('active');
    });
  });
}

function initializeAll() {
  initMultiVariantForms();
  initAutoSubmitSizeOptions();
  initPopupHandlers();
}

document.addEventListener('DOMContentLoaded', initializeAll);

// Re-initialize when new nodes are added (e.g. via Instant navigation or dynamic sections)
const observer = new MutationObserver((mutations) => {
  mutations.forEach(() => {
    initializeAll();
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
